export default "__VITE_ASSET__356d0845__"